import { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import { MISSING_DATA_PLACEHOLDER } from '@investigator/shared/constants';
import { CommunicatingEntityDetail } from '../../types/entityCommunication';

export interface EntityCommunicationRowProps {
  entity: CommunicatingEntityDetail;
  isLast?: boolean;
}

export const EntityCommunicationRow = ({
  entity,
  isLast,
}: EntityCommunicationRowProps): JSX.Element => {
  const formattedTime = useMemo(() => {
    if (!entity.timestamp || entity.timestamp === 0) {
      return { time: '-', date: '-' };
    }
    const date = moment(entity.timestamp);
    if (!date.isValid()) {
      return { time: '-', date: '-' };
    }
    return {
      time: date.format('HH:mm:ss'),
      date: date.format('M/D/YYYY'),
    };
  }, [entity.timestamp]);

  return (
    <Flex
      w="100%"
      py={2}
      data-testid="entity-communication-row"
      borderBottom={isLast ? 'none' : '1px solid'}
      borderColor="border.layer.1"
      display="grid"
      gridTemplateColumns="80px 1fr 70px 50px"
      gap={8}
    >
      <Flex direction="column">
        <Text
          fontSize="sm"
          lineHeight="5"
          fontWeight="medium"
          color="text.primary"
          textAlign="left"
          display="block"
        >
          {formattedTime.time}
        </Text>
        <Text
          fontSize="sm"
          lineHeight="5"
          color="text.secondary"
          textAlign="left"
          display="block"
        >
          {formattedTime.date}
        </Text>
      </Flex>
      <Flex direction="column">
        <Text
          fontSize="sm"
          lineHeight="5"
          fontWeight="medium"
          color="text.primary"
          textAlign="left"
          display="block"
        >
          {entity.entityIp}
        </Text>
        {entity.macAddress && (
          <Text
            fontSize="sm"
            lineHeight="5"
            color="text.secondary"
            textAlign="left"
            display="block"
          >
            {entity.macAddress}
          </Text>
        )}
      </Flex>
      <Flex direction="column">
        <Text
          fontSize="sm"
          lineHeight="5"
          fontWeight="medium"
          color="text.primary"
          textAlign="left"
          display="block"
        >
          {entity.port || MISSING_DATA_PLACEHOLDER}
        </Text>
        <Text
          fontSize="sm"
          lineHeight="5"
          color="text.secondary"
          textTransform="uppercase"
          textAlign="left"
          display="block"
        >
          {entity.protocol || MISSING_DATA_PLACEHOLDER}
        </Text>
      </Flex>
      <Flex direction="column">
        <Text
          fontSize="sm"
          lineHeight="5"
          fontWeight="medium"
          color="text.primary"
          textAlign="left"
        >
          {entity.count}
        </Text>
      </Flex>
    </Flex>
  );
};
